<template>
  <div class="senspro">
    <el-form label-width="20px" :model="form" style="width:95%;">
      <el-form-item label="">
        <p class="b_p">企业周边500M人口：</p>
        <el-radio-group v-model="form.surround500m" size="small">
          <el-radio :label="1" disabled>&lt;500</el-radio>
              <el-radio :label="2" disabled>500-1000</el-radio>
              <el-radio :label="3" disabled>>1000</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="">
        <p class="b_p">企业周边5KM人口：</p>
        <el-radio-group v-model="form.surround5km" size="small">
          <el-radio :label="1" disabled>&lt;1万</el-radio>
              <el-radio :label="2" disabled>1万-5万</el-radio>
              <el-radio :label="3" disabled>>5万</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="" class="arr_b">
        <p class="b_p">企业雨水排口、清净下水排口、污水排口下游10km存在的环境风险受体（多选）：</p>
        <el-checkbox-group v-model="checkList">
          <el-checkbox disabled label="1">乡镇及以上城镇饮用水水源（地表水或地下水）保护区</el-checkbox>
          <el-checkbox disabled label="2">自来水厂取水口</el-checkbox>
          <el-checkbox disabled label="3">水源涵养区</el-checkbox>
          <el-checkbox disabled label="4">自然保护区</el-checkbox>
          <el-checkbox disabled label="5">重要湿地</el-checkbox>
          <el-checkbox disabled label="6">珍稀濒危野生动植物天然集中分布区</el-checkbox>
          <el-checkbox disabled label="7">重要水生生物的自然产卵场及索饵场、越冬场和洄游通道</el-checkbox>
          <el-checkbox disabled label="8">风景名胜区</el-checkbox>
          <el-checkbox disabled label="9">特殊生态系统</el-checkbox>
          <el-checkbox disabled label="10">世界文化和自然遗产地</el-checkbox>
          <el-checkbox disabled label="11">红树林、珊瑚礁等滨海湿地生态系统</el-checkbox>
          <el-checkbox disabled label="12">珍稀、濒危海洋生物的天然集中分布区</el-checkbox>
          <el-checkbox disabled label="13">海洋特别保护区</el-checkbox>
          <el-checkbox disabled label="14">海上自然保护区</el-checkbox>
          <el-checkbox disabled label="15">盐场保护区</el-checkbox>
          <el-checkbox disabled label="16">海水浴场</el-checkbox>
          <el-checkbox disabled label="17">海洋自然历史遗迹</el-checkbox>
          <el-checkbox disabled label="18">水产养殖区</el-checkbox>
          <el-checkbox disabled label="19">天然渔场</el-checkbox>
          <el-checkbox disabled label="20">耕地、基本农田保护区</el-checkbox>
          <el-checkbox disabled label="21">富营养化水域</el-checkbox>
          <el-checkbox disabled label="22">基本草原</el-checkbox>
          <el-checkbox disabled label="23">森林公园</el-checkbox>
          <el-checkbox disabled label="24">地质公园</el-checkbox>
          <el-checkbox disabled label="25">天然林</el-checkbox>
          <el-checkbox disabled label="26">海滨风景游览区</el-checkbox>
          <el-checkbox disabled label="27">具有重要经济价值的海洋生物生存区域</el-checkbox>
          <el-checkbox label="28" disabled>以上都没有</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="" class="arr_bs">
        <p class="b_p">24小时流经范围（单选）：</p>
        <el-radio-group v-model="form.throughRange24h">
          <el-radio :label="1" disabled>以企业雨水排口（含泄洪渠）、清净下水排口、废水总排口算起，排水进入受纳河流最 大流速时，24小时流经范围内涉跨国界或省界的；</el-radio>
          <el-radio :label="2" disabled>24小时流经范围内不涉跨国界或省界</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="">
        <p class="b_p">影响半径(千米)：<span>{{form.affectRadius}}</span></p>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import workbrnch from './../../data/emer/burst.js'
export default {
  data() {
    return {
      disabled: false,
      center: [],
      points: [],
      // 基本信息
      form: {
        affectRadius: 10,
        envRiskReceptor10km: '',
        planId: '',
        surround500m: '',
        surround5km: '',
        throughRange24h: ''
      },
      // 多选
      checkList: [],
      isSave: false,
      planId: ''
    }
  },
  created() {
    if (!sessionStorage.planIdLists) return
    this.planId = sessionStorage.planIdLists
    this.sensprotection_list()
  },
  methods: {
    // 获取列表
    sensprotection_list() {
      (async() => {
        try {
          let info = await workbrnch.get_sensprotection_list({
            planId: this.planId
          })
          if (info.status && info.data) {
          // if (info) {
            let newform = info.data
            // newform.affectRadius = parseInt(newform.affectRadius)
            // newform.affectRadius = newform.affectRadius
            this.form = newform
            this.checkList = info.data.envRiskReceptor10km.split(',')
          }
        } catch (err) {
          console.log(err)
        }
      })()
    },
  }
}

</script>
<style scoped lang="stylus">
.senspro {
  position: relative;
  overflow: auto;
  height: 588px;
}

.el-checkbox,
.el-checkbox__input {
  white-space: normal
}

.el-form-item {
  margin-bottom: 20px;
}

.el-form-item__content {
  position: relative;
  left: -15px;
}

.el-checkbox-group {
  position: relative;
  left: -15px;
  label {
    display: block;
    line-height: 30px;
    &:first-child {
      margin-left: 15px;
    }
    span {
      word-break: normal;
      width: auto;
      display: block;
      white-space: pre-wrap;
      word-wrap: break-word;
      overflow: hidden;
    }
  }
}

.el-form-item__content {
  .el-radio-group {
    label {
      line-height: 30px;
      &:first-child {
        white-space: normal;
      }
    }
  }
}

.arr_bs {
  label {
    &:nth-child(2) {
      margin-left: 0;
    }
  }
}

.map {
  width: 90%;
  height: 500px;
  position: relative;
  left: 50px;
}

.b_p {
  position: relative;
  left: 0px;
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// Sensprotection.vue?6053b5d8